import { useIsTimelineExpanded } from "../singleTimelineStore";
import { Button } from "@mui/material";
import styled from "styled-components/macro";
import { ExpandMore } from "@mui/icons-material";
import { useIsDarkMode } from "store/atoms";
import { blueButton, darkModeLinkColor } from "constants/colors";

export function BtnExpandCollapseTimeline() {
  const [isTimelineExpanded, setIsTimelineExpanded] = useIsTimelineExpanded();
  const [isDarkMode] = useIsDarkMode();
  return (
    <BtnExpandCollapseTimelineStyles $isDarkMode={isDarkMode}>
      <Button
        onClick={() => setIsTimelineExpanded(!isTimelineExpanded)}
        startIcon={
          <ExpandMore
            style={{
              transform: `scale(1.4) rotate(${
                isTimelineExpanded ? -0.5 : 0
              }turn)`,
            }}
          />
        }
      >
        {isTimelineExpanded ? "Collapse Timeline" : "Expand Timeline"}
      </Button>
    </BtnExpandCollapseTimelineStyles>
  );
}
const BtnExpandCollapseTimelineStyles = styled.div<{
  $isDarkMode: boolean;
}>`
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  button.MuiButtonBase-root {
    height: 100%;
    text-transform: none;
    color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeLinkColor : blueButton};
    padding: 6px 14px;
  }
  .MuiSvgIcon-root {
    transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  }
`;
